import { clsx } from 'clsx';
import { FC } from 'react';
import { ConnectionStatusType } from '@/components/connection-status/connection-status-type.ts';
import {
  connectionStatus,
  connectionStatusLabel,
} from '@/components/connection-status/connection-status.css.ts';
import { useConnectionStatus } from '@/components/connection-status/use-connection-status.ts';
import { InteractiveStatus } from '@/components/interactive-status/interactive-status.tsx';

const DEFAULT_TOOLTIPS: Record<ConnectionStatusType, string> = {
  [ConnectionStatusType.Connected]: 'Connected, real-time data is available',
  [ConnectionStatusType.Connecting]: 'Connecting, please wait',
  [ConnectionStatusType.Disconnected]:
    'Connection lost, please reload the page',
};

export const ConnectionStatus: FC<{
  subscriptionStatus: ConnectionStatusType;
  connectedLabel?: string;
  tooltips?: Partial<Record<ConnectionStatusType, string>>;
  className?: string;
  containerClassName?: string;
  iconClassName?: string;
}> = ({
  subscriptionStatus,
  connectedLabel,
  tooltips,
  className,
  containerClassName,
  iconClassName,
}) => {
  const { icon: Icon, label, status } = useConnectionStatus(subscriptionStatus);

  const displayLabel =
    connectedLabel && status === ConnectionStatusType.Connected
      ? connectedLabel
      : label;

  const resolvedTooltips = tooltips
    ? { ...DEFAULT_TOOLTIPS, ...tooltips }
    : DEFAULT_TOOLTIPS;

  return (
    <InteractiveStatus
      icon={<Icon />}
      variant={
        status === ConnectionStatusType.Connected ? 'active' : 'inactive'
      }
      tooltipDescription={resolvedTooltips[status]}
      className={clsx(connectionStatus, className)}
      iconClassName={iconClassName}
      containerClassName={containerClassName}
    >
      <span className={connectionStatusLabel}>{displayLabel}</span>
    </InteractiveStatus>
  );
};
